module.exports = __webpack_public_path__ + "img/00018.b88e06be.webp";